// extracted by mini-css-extract-plugin
module.exports = {"slider":"CycleCalendarSlider_slider__eZwxW","button":"CycleCalendarSlider_button__rdAEc"};